/**
 * Explicit map: team / Team Leaders parameter name (API English) → lexicon ID.
 * Used so we always translate via l(id) regardless of current UI language.
 * Keys are normalized to lowercase for lookup.
 * Full list from lexicon.
 */
export const TEAM_PARAMETER_LEXICON_MAP = {
  'competitions': 1,
  'my profile': 2,
  'teams': 3,
  'search by team name': 4,
  'players': 5,
  'search by player name': 6,
  'matches': 7,
  'stats': 8,
  'events': 9,
  'match name': 10,
  'position': 11,
  'select matches': 12,
  'select parameters': 13,
  'download in xls': 14,
  'list of matches': 15,
  'choose matches': 16,
  'mistakes': 17,
  'shots': 18,
  'passes': 19,
  'duels': 20,
  'referee decisions': 21,
  'gk events': 22,
  'other events': 23,
  'tactics': 24,
  'no options selected': 25,
  'watch % events': 26,
  'video settings': 27,
  'download pic': 28,
  'offset': 29,
  'save': 30,
  'grave mistake': 31,
  'grave goal mistake': 32,
  'shot wide': 33,
  'shot into the bar/post': 34,
  'goal': 35,
  'own goal': 36,
  'shot on target': 37,
  'set piece cross with goal': 38,
  'assist': 39,
  'misplaced crossing from set piece with a shot': 40,
  'misplaced crossing from set piece with a goal': 41,
  'non attacking pass inaccurate': 42,
  'accurate crossing from set piece with a goal': 43,
  'cross': 44,
  'set piece cross with shot': 45,
  'accurate pass': 46,
  'inaccurate pass': 47,
  'inaccurate key pass': 48,
  'key assist': 49,
  'assisting': 50,
  'accurate cross': 51,
  'accurate crossing from set piece with a shot': 52,
  'inaccurate set-piece cross': 53,
  'pass into offside': 54,
  'accurate key pass': 55,
  'accurate crossing from set piece': 56,
  'key duel': 57,
  'key dribbling': 58,
  'duel': 59,
  'air duel': 60,
  'tackle': 61,
  'dribble past opponent +': 62,
  'dribbling': 63,
  'dribble past opponent -': 64,
  'red card': 65,
  'foul not detected': 66,
  'goal disallowed': 67,
  'penalty not awarded': 68,
  'offside not detected': 69,
  'foul': 70,
  'yellow card': 71,
  'cancelled yc': 72,
  'rc for two yc': 73,
  'gk interception +': 74,
  'effective save': 75,
  'gk interception -': 76,
  'clearance': 77,
  'recovered balls': 78,
  'ball receiving': 79,
  'inaccurate blocked cross': 80,
  'ball out of the field': 81,
  'opening': 82,
  'offside': 83,
  'gs opportunity +': 84,
  'gs opportunity -': 85,
  'gs opp. created': 86,
  'gs opp. not scored': 87,
  'blocked shot': 88,
  'shot interception': 89,
  'pass interception': 90,
  'cross interception': 91,
  'bad ball control': 92,
  'lost balls': 93,
  'inaccurate cross': 94,
  'players, that created offside trap': 95,
  'gs opp. scored': 96,
  'blocked shot by field player': 97,
  'picking up': 98,
  'statistics': 99,
  'matches played per competition:': 100,
  'all competition stats:': 101,
  'goals scored': 102,
  'red cards': 103,
  'yellow cards': 104,
  'assists': 105,
  'total passes': 106,
  'accurate passes': 107,
  'accurate passes, %': 108,
  'inaccurate passes': 109,
  'dob': 110,
  'nationality': 111,
  'foot': 112,
  'height': 113,
  'primary position': 114,
  'secondary positions': 115,
  'download': 116,
  'match statistics': 117,
  'full match': 118,
  'formation': 119,
  'key stats': 120,
  'date': 121,
  'opponent': 122,
  'score': 123,
  'my playlist': 124,
  'shared playlist': 125,
  'language': 126,
  'english': 127,
  'change email address': 128,
  'recently visited list': 129,
  'theme': 130,
  'contact your account manager': 131,
  'sort by date': 132,
  'add': 133,
  'the playlist list is empty': 134,
  'the shared playlist list is empty': 135,
  'settings': 136,
  'favorites': 435,
  'more...': 310,
  'resolutions not available yet': 311,
  'loading...': 312,
  'login': 313,
  'no results': 314,
  'no matches': 315,
  'no video link': 316,
  'no teams': 317,
  'goals conceded': 318,
  'player name': 319,
  'player profile': 320,
  'players list': 321,
  'password': 322,
  'confirm password': 323,
  'goal mistakes': 324,
  'matches played': 325,
  'on-ball events': 326,
  'age': 327,
  'fouls': 328,
  'full name': 329,
  'key passes': 330,
  'aerial duels': 331,
  'dribbles past opponent': 332,
  'offsides': 333,
  'obe': 334,
  'ball interceptions': 335,
  'ball losses': 336,
  'ball recoveries': 337,
  'video player': 338,
  'download in xml': 339,
  'team profile': 340,
  'user name/email': 341,
  'license agreement': 342,
  'register': 343,
  "don't have an account yet? register": 344,
  'already have an account? log in': 345,
  'mins played': 346,
  'type country or competition name here…': 349,
  'substitute player': 414,
  'left': 415,
  'right': 416,
  'right + left': 417,
  'ld': 390,
  'gk': 399,
  'lm': 391,
  'lam': 392,
  'lf': 393,
  'lcd': 394,
  'lcdm': 395,
  'lcm': 396,
  'lcam': 397,
  'lcf': 398,
  'cd': 400,
  'cdm': 401,
  'cm': 402,
  'cam': 403,
  'cf': 404,
  'rcd': 405,
  'rcdm': 406,
  'rcm': 407,
  'rcam': 408,
  'rcf': 409,
  'rd': 410,
  'rm': 411,
  'ram': 412,
  'rf': 413,
  'main page': 418,
  'no available competitions': 419,
  'to competition': 420,
  'show direction': 421,
  'whole pitch': 422,
  'football pitch settings': 423,
  'goals': 424,
  'no available seasons': 425,
  'add to playlist': 426,
  'download all videos': 427,
  'main': 428,
  'gs opportunities': 429,
  'ball movement': 430,
  'ball possession': 431,
  'neutral ball recoveries': 432,
  'add to favs?': 433,
  'remove from favs?': 434,
  'you have successfully shared your playlist': 439,
  "an error has occurred, we can't share the playlist": 440,
  'type user email to search': 441,
  'selected emails': 442,
  'no user selected': 443,
  'found emails': 444,
  'the list of users is empty': 445,
  'confirm': 446,
  'your favorites list is empty': 447,
  'volume': 448,
  'playback speed': 449,
  'zones': 450,
  'back': 451,
  'none': 452,
  'season': 453,
  'competition': 454,
  'reset': 457,
  'no players': 458,
  'ball possession, sec': 459,
  'ball possession, %': 460,
  'corners': 461,
  'shots on target': 462,
  'shots on target, %': 463,
  'no data available': 464,
  'event': 465,
  'min of match': 466,
  'description': 467,
  'names': 468,
  'teams parameters': 469,
  'general': 549,
  'on-ball events +': 550,
  'on-ball events, %': 551,
  'on-ball events -': 552,
  'on-ball events -, %': 553,
  'fouls suffered': 554,
  'yellow-red cards': 555,
  'grave mistakes': 556,
  'goals/chances/shots': 557,
  'goals +': 558,
  'goals penalties +': 559,
  'goal scoring opportunities': 560,
  'goal scoring opportunities +': 561,
  'goal scoring opportunities +,%': 562,
  'goal scoring opportunities -': 563,
  'goal scoring opportunities -, %': 564,
  'goal scoring opportunities created': 565,
  'goal scoring opportunities created +': 566,
  'goal scoring opportunities created +, %': 567,
  'goal scoring opportunities created -': 568,
  'goal scoring opportunities created -, %': 569,
  'shots wide': 570,
  'shots wide, %': 571,
  'shots blocked': 572,
  'shots blocked, %': 573,
  'shots on post or bar': 574,
  'shots on post or bar, %': 575,
  'shots from free kick': 576,
  'shots from free kick, %': 577,
  'passes +': 578,
  'passes +, %': 579,
  'passes +,%': 579,
  'passes -': 580,
  'passes -, %': 1209,
  'passes -,%': 581,
  'passes into duel': 582,
  'passes into duel +': 583,
  'passes into duel +, %': 584,
  'passes into duel -': 585,
  'passes into duel -, %': 586,
  'crosses': 587,
  'crosses +': 588,
  'crosses +, %': 589,
  'crosses +,%': 1222,
  'crosses -': 590,
  'crosses -, %': 591,
  'passes received': 592,
  'passes into duel received': 593,
  'passes into duel received, %': 594,
  'crosses received': 595,
  'crosses received, %': 596,
  'advanced passes': 597,
  'key passes +': 598,
  'key passes +, %': 599,
  'key passes -': 600,
  'key passes -, %': 601,
  'progressive passes': 602,
  'progressive passes +': 603,
  'progressive passes +, %': 604,
  'progressive passes -': 605,
  'progressive passes -, %': 606,
  'key passes received': 607,
  'key passes received, %': 608,
  'progressive passes received': 609,
  'progressive passes received, %': 610,
  'duels +': 611,
  'duels +, %': 612,
  'duels -': 613,
  'duels -, %': 614,
  'aerial duels +': 615,
  'aerial duels +, %': 616,
  'aerial duels -': 617,
  'aerial duels -, %': 618,
  'duels in offence': 619,
  'duels in offence +': 620,
  'duels in offence +, %': 621,
  'duels in offence -': 622,
  'duels in offence -, %': 623,
  'duels in defence': 624,
  'duels in defence +': 625,
  'duels in defence +, %': 626,
  'duels in defence -': 627,
  'duels in defence -, %': 628,
  'in defence': 629,
  'tackles made': 630,
  'tackles made +': 631,
  'tackles made +, %': 632,
  'tackles made -': 633,
  'tackles made -, %': 634,
  'interceptions': 635,
  'interceptions +': 636,
  'interceptions +, %': 637,
  'interceptions -': 638,
  'interceptions -, %': 639,
  'blocked shots': 640,
  'clearances': 641,
  'dribbles faced': 642,
  'dribbles faced +': 643,
  'dribbles faced +, %': 644,
  'dribbles faced -': 645,
  'dribbles faced -, %': 646,
  'in offence': 647,
  'dribbles made': 648,
  'dribbles made +': 649,
  'dribbles made +, %': 650,
  'dribbles made -': 651,
  'dribbles made -, %': 652,
  'progressive carries': 653,
  'tackles faced': 654,
  'tackles faced +': 655,
  'tackles faced +, %': 656,
  'tackles faced -': 657,
  'tackles faced -, %': 658,
  'possessions involved': 659,
  'possessions involved, %': 660,
  'possessions involved with shots': 661,
  'possessions involved with shots, %': 662,
  'passes by distance': 663,
  'short passes': 664,
  'short passes +': 665,
  'short passes +, %': 666,
  'short passes -': 667,
  'short passes -, %': 668,
  'medium passes': 669,
  'medium passes +': 670,
  'medium passes +, %': 671,
  'medium passes -': 672,
  'medium passes -, %': 673,
  'long passes': 674,
  'long passes +': 675,
  'long passes +, %': 676,
  'long passes -': 677,
  'long passes -, %': 678,
  'short passes received': 679,
  'short passes received, %': 680,
  'medium passes received': 681,
  'medium passes received, %': 682,
  'long passes received': 683,
  'long passes received, %': 684,
  'passes onward': 685,
  'passes onward +': 686,
  'passes onward +, %': 687,
  'passes onward -': 688,
  'passes onward -, %': 689,
  'passes rearward': 690,
  'passes rearward +': 691,
  'passes rearward +, %': 692,
  'passes rearward -': 693,
  'passes rearward -, %': 694,
  'passes sideways': 695,
  'passes sideways +': 696,
  'passes sideways +, %': 697,
  'passes sideways -': 698,
  'passes sideways -, %': 699,
  'passes onward received': 700,
  'passes onward received, %': 701,
  'passes rearward received': 702,
  'passes rearward received, %': 703,
  'passes sideways received': 704,
  'passes sideways received, %': 705,
  'passes by side': 706,
  'name of competition': 714,
  'goal chance': 715,
  'goals -': 716,
  'goal chance +': 717,
  'goal chance -': 718,
  'goal chance allowed': 719,
  'goal chance allowed +': 720,
  'goal chance allowed -': 721,
  'passes in challenge': 722,
  'passes in challenge +': 723,
  'passes in challenge -': 724,
  'long ball attacks with goals': 725,
  'ball recoveries within 5 seconds': 726,
  'ball recoveries within 10 seconds': 727,
  'ball losses within 5 seconds': 728,
  'ball losses within 10 seconds': 729,
  'set pieces': 730,
  'free kicks': 731,
  'throw-ins': 732,
  'indirect free kicks': 733,
  'goal kicks': 734,
  'attack types': 735,
  'attacks, all': 736,
  'attack - left flank': 737,
  'attack with goals - left flank': 738,
  'attack - center flank': 739,
  'attack with goals - center flank': 740,
  'attack - right flank': 741,
  'attack with goals - right flank': 742,
  'positional attacks': 743,
  'positional attacks with goals': 744,
  'fast attacks': 745,
  'fast attacks with goals': 746,
  'set pieces attacks': 747,
  'attacks with goals - set pieces attacks': 748,
  'free kick attacks': 749,
  'free kick attacks with goals': 750,
  'corner attacks': 751,
  'corner attacks with goals': 752,
  'throw-in attacks': 753,
  'throw-in attacks with goals': 754,
  'goals - free kick attack': 755,
  'penalties': 756,
  'penalties scored': 757,
  'wing attacks': 758,
  'wing attacks with goals': 759,
  'counter-attacks': 760,
  'counter-attacks with a goal': 761,
  'counterpress attack': 762,
  'counterpress attack with goals': 763,
  'long ball attacks': 764,
  'penalty goals +': 765,
  'goal scoring opportunities allowed': 766,
  'goal scoring opportunities allowed +': 767,
  'goal scoring opportunities allowed -': 768,
  "opponent's shots": 769,
  "opponent's shots on target": 770,
  'effective saves': 771,
  'saved shots': 772,
  'gk bouncing saves': 773,
  'gk bouncing saves +': 774,
  'gk bouncing saves -': 775,
  'penalties faced': 776,
  'penalty goals conceded': 777,
  'penalties saved': 778,
  'gk interceptions': 779,
  'gk interceptions +': 780,
  'gk interceptions -': 781,
  'gk hand passes': 782,
  'gk hand passes +': 783,
  'gk hand passes -': 784,
  'average position': 785,
  'gk goal kick passes': 786,
  'gk goal kick passes -': 787,
  'average position in offence': 788,
  'average position in defence': 789,
  'saved shots, %': 790,
  'penalties saved, %': 791,
  'gk interceptions, %': 792,
  'gk interceptions -, %': 793,
  'gk hand passes +, %': 794,
  'gk hand passes -, %': 795,
  'gk goal kick passes +': 796,
  'gk goal kick passes +, %': 797,
  'gk goal kick passes -, %': 798,
  'gk bouncing saves +, %': 799,
  'pre-set': 994,
  'start searching, teams, players or competitions': 903,
  'flag search': 904,
  'search by flag': 905,
  'search': 906,
  'load more': 907,
  'load less': 908,
  'history': 909,
  'check out all competitions.': 910,
  'number of competitions all around the world': 911,
  'matches with videos': 912,
  'type competition or country': 913,
  'please select competition!': 915,
  'nothing found': 914,
  'see competition': 916,
  'check out all players.': 917,
  'compare players': 918,
  'average match': 919,
  'type season': 920,
  'type name': 921,
  'type position': 922,
  'type country name': 923,
  'select team type': 924,
  'select gender': 925,
  'select leg': 926,
  'age from': 927,
  'age to': 928,
  'height from (cm)': 929,
  'height to (cm)': 930,
  'select statistics (per match)': 931,
  'select statistics (per season)': 932,
  'minutes (from)': 933,
  'minutes (to)': 934,
  'goals (from)': 935,
  'goals (to)': 936,
  'assist (from)': 937,
  'assist (to)': 938,
  'crosses (from)': 939,
  'crosses (to)': 940,
  'interception + (from)': 941,
  'interception + (to)': 942,
  'pass accuracy (in %) - (from)': 943,
  'pass accuracy (in %) - (to)': 944,
  'duels + (in %) - (from)': 945,
  'duels + (in %) - (to)': 946,
  'ball recoveries (from)': 947,
  'ball recoveries (to)': 948,
  'tackles (from)': 949,
  'tackles (to)': 950,
  'dribblings + (in %) - (from)': 951,
  'dribblings + (in %) - (to)': 952,
  'shots + (in %) - (from)': 953,
  'shots + (in %) - (to)': 954,
  'aerial duels + (in %) - (from)': 955,
  'aerial duels + (in %) - (to)': 956,
  'effective saves (from)': 957,
  'effective saves (to)': 958,
  'clean sheets (from)': 959,
  'clean sheets (to)': 960,
  'see your favorites list.': 961,
  'sort by alphabet': 962,
  'see more': 963,
  'see your playlists.': 964,
  'share folder': 965,
  'enter email': 966,
  'add email': 967,
  'share playlist': 968,
  'rename folder': 969,
  'folder name': 970,
  'rename': 971,
  'delete folder': 972,
  "are you sure you want to delete the 'folder name'/'video name' and all the videos inside it? deleting the folder will also delete all the videos.": 973,
  'delete': 974,
  'add new folder': 975,
  'add folder': 976,
  'set up the platform for yourself.': 977,
  'switch mode': 978,
  'you may change the platform mode here by selecting dark or light': 979,
  'mode': 980,
  'dark mode': 981,
  'light mode': 982,
  "let's get in touch.": 983,
  'this is your personalized support touch': 984,
  "also, you can contact us directly at sales@smrtstats.com if you have some other issues that we can help.": 985,
  'send message': 986,
  'check out the team.': 987,
  'overview': 988,
  'in attack: videos': 989,
  'in defense: videos': 990,
  'opponents': 991,
  'select season': 992,
  'select competition': 993,
  'choose season & match parameters': 995,
  'choose other parameters': 996,
  'enable drawing': 997,
  'watch events': 998,
  'add offset': 999,
  'own shots': 1000,
  'spots on field': 1001,
  'spots in goal': 1002,
  'check out the player.': 1003,
  'current club': 1004,
  'past club': 1005,
  'weight': 1006,
  'compare player': 1007,
  'compare': 1008,
  'player rankings': 1009,
  'team rankings': 1010,
  'goalkeepers': 1011,
  'show more': 1012,
  'show less': 1013,
  'apply filter': 1014,
  'check out the match statistics.': 1015,
  'match events': 1016,
  'player statistics': 1017,
  'filter': 1018,
  'play full match': 1019,
  'see match statistics': 1020,
  'see match formation': 1021,
  'download full match': 1022,
  'clear': 1023,
  "this is a beta version. we would be grateful if you contribute and help us make it better.": 1024,
  'take screenshot': 1025,
  'record': 1026,
  'add record to playlist': 1027,
  'remove record': 1028,
  'download video': 1029,
  'start offset': 1030,
  'end offset': 1031,
  'home': 1032,
  'smrt search': 1033,
  'send message': 1034,
  'log out': 1035,
  'platform setup': 1036,
  'beta': 1037,
  'club': 1038,
  'clubs': 1039,
  'please select filters': 1040,
  'type competition name': 1041,
  'national': 1042,
  'male': 1043,
  'female': 1044,
  'clean sheets': 1045,
  'successfully added to compare': 1046,
  'go to compare': 1047,
  'no results for players': 1048,
  'search & compare players.': 1049,
  'remove all': 1050,
  'add to compare': 1051,
  "there is nothing in here. start exploring competitions or players, and click on the star icon makes tournament, team, or player favorite.": 1052,
  'go to competitions page': 1053,
  'go to players page': 1054,
  'link to playlist has been emailed to recipient(s).': 1055,
  'okay': 1056,
  'nothing in here for now. start adding videos.': 1057,
  "there is nothing in here, you can add new folder playlist and to start adding videos.": 1058,
  'team overview': 1059,
  'team leaders': 1060,
  'videos': 1061,
  "opponent's counter attacks": 1062,
  "opponent's free kicks": 1063,
  "opponent's penalties": 1064,
  "opponent's goal opportunities": 1065,
  'all matches': 1066,
  'last match': 1688,
  'last 3 matches': 1067,
  'last 5 matches': 1068,
  'last 10 matches': 1069,
  'deselect all matches': 1070,
  'see more about player': 1071,
  'fetching data': 1072,
  'team events': 1073,
  'disable drawing': 1074,
  'no player info available': 1075,
  'team shots': 1076,
  'team crosses': 1077,
  'own crosses': 1078,
  'player overview': 1079,
  'initiate contact': 1080,
  'someone from team will initiate contact between you and player': 1081,
  'you will be notified…': 1082,
  'tournament statistic': 1083,
  'outfield players': 1084,
  'video events': 1085,
  'one clip': 1086,
  'separate clips': 1087,
  'select playlist': 1088,
  'create new playlist': 1089,
  'write name': 1090,
  'navigation': 1091,
  'professional': 1092,
  'access denied': 1610,
  'passes onward': 1240,
  'passes rearward': 1245,
  'passes sideways': 1250,
  'passes recieved': 1260,
  'passes into duel received': 1261,
  'passes into duel received, %': 1262,
  'aerial duels': 1297,
  'aerial duels +': 1298,
  'aerial duels +, %': 1299,
  'aerial duels -': 1300,
  'aerial duels -, %': 1301,
  'duels in offence': 1302,
  'duels in offence +': 1303,
  'duels in offence +, %': 1304,
  'duels in offence -': 1305,
  'duels in offence -, %': 1306,
  'duels in defence': 1307,
  'duels in defence +': 1308,
  'duels in defence +, %': 1309,
  'duels in defence -': 1310,
  'duels in defence -, %': 1311,
  'ball recoveries': 1328,
  'ball losses': 1329,
  'goal mistakes': 1331,
  'grave mistakes': 1332,
  'possessions involved with shots': 1339,
  'possessions involved with shots, %': 1340,
  'goal scoring opportunities allowed +, %': 1352,
  'goal scoring opportunities allowed -, %': 1354,
  'shots from free kick': 1374,
  'shots from free kick, %': 1375,
  'premium access': 1608,
  "you can't select this video because your access is denied. please contact your account manager for assistance.": 1611,
  "videos are available for standard users *x* hours after upload. for access to videos in 2 hours or less after upload, please contact your account manager to subscribe for premium video access": 1609,
  'access denied, please contact your account manager.': 1612,
  'ppda': 1493,
  'ball possession, min': 1494,
  'ball possessuion, quantity': 1495,
  'average duration of ball possession, min': 1496,
  'ball possession (0-10 sec)': 1497,
  'ball possession (10-20 sec)': 1498,
  'ball possession (20-45 sec)': 1499,
  'ball possession (>45 sec)': 1500,
  'attacks - all': 1501,
  'attacks - left wing': 1502,
  'attacks with goals - left wing': 1503,
  'attacks with goals - left wing, %': 1504,
  'attacks - center': 1505,
  'attacks with goals - center': 1506,
  'attacks with goals - center, %': 1507,
  'attacks - right wing': 1508,
  'attacks with goals - right wing': 1509,
  'attacks with goals - right wing, %': 1510,
  'positional attacks': 1511,
  'positional attacks with goals': 1512,
  'positional attacks with goals, %': 1513,
  'quick attacks': 1514,
  'quick attacks with goals': 1515,
  'quick attacks with goals, %': 1516,
  'set piece attacks': 1517,
  'set piece attacks with goals': 1518,
  'set piece attacks with goals, %': 1519,
  'free kick attacks with goals, %': 1522,
  'corner attacks with goals, %': 1525,
  'throw-in attacks with goals, %': 1528,
  'free kick attacks with goals': 1529,
  'free kick attacks with goals, %': 1530,
  'penalties scored, %': 1533,
  'wing attacks with goals, %': 1536,
  'counter-attacks with a goal, %': 1539,
  'counter-pressing attacks': 1540,
  'counter-pressing attacks with goals': 1541,
  'counter-pressing attacks with goals, %': 1542,
  'long ball attacks with goals, %': 1545,
  'smrt index': 1546,
  'mins played': 1171,
  'on-ball events': 1184,
  'on-ball events +': 1185,
  'on-ball events, %': 1186,
  'on-ball events -': 1187,
  'on-ball events -, %': 1188,
  'fouls suffered': 1190,
  'shots on target': 1195,
  'shots on target, %': 1196,
  'shots wide': 1197,
  'shots wide, %': 1198,
  'shots blocked': 1199,
  'shots blocked, %': 1200,
  'shots on post or bar': 1201,
  'shots on post or bar, %': 1202,
  'shots from free kick': 1203,
  'shots from free kick, %': 1204,
  'passes -, %': 1209,
  'passes into duel': 1210,
  'passes into duel +': 1211,
  'passes into duel +, %': 1212,
  'passes into duel -': 1213,
  'passes into duel -, %': 1214,
  'key passes': 1215,
  'short passes': 1225,
  'medium passes ': 1230,
  'medium passes - ': 1233,
  'start searching for teams, players, or competitions': 1656,
};

/**
 * Get lexicon ID for a team parameter name (DEPRECATED - use useParameterLexicon hook instead)
 * This function now returns null and should not be used.
 * @param {string} parameterName - The parameter name from backend
 * @returns {number|null} - Always returns null, use useParameterLexicon hook instead
 * @deprecated Use useParameterLexicon hook instead
 */
export const getTeamParameterLexiconId = (parameterName) => {
  return null;
};
